import React from "react";
import { Button } from "@chakra-ui/react";
import SellersTable from "./SellersTable";
import UsersFilter from "../UsersFilter";
import ContentCard from "../../Common/Layout/ContentCard";
import { useHistory } from "react-router-dom";
import Body from "../../Common/Body";

const Sellers = () => {
  const history = useHistory();
  return (
    <Body title={"Lista de vendedores"}>
      <ContentCard>
        <UsersFilter role={3}></UsersFilter>
      </ContentCard>
      <ContentCard>
        <Button
          my="2"
          colorScheme="blue"
          onClick={() => history.push("/usuarios/nuevo?roleId=3")}
        >
          + Vendedor
        </Button>
        <SellersTable></SellersTable>
      </ContentCard>
    </Body>
  );
};

export default Sellers;
